import { forwardRef, useMemo } from "react";
import { array, bool, func, instanceOf, object, shape } from "prop-types";
import styled from "styled-components/macro";
import { rem } from "polished";

import { colors } from "../../../styles/Styles.variables";
import { routes } from "../../../constants/routes";

import PageLogoHoltCat from "./Page.logo-holtcat";
import PageDesktopFooterColophon from "./Page.desktop.footer.colophon";
import PageDesktopFooterNav from "./Page.desktop.footer.nav";
import SignupFooter from "../../signup-footer";

function PageDesktopFooter({
  authenticated,
  forwardedRef,
  location,
  settingsLinks,
  signupFooterShow,
  trackEvent,
  trackOutboundLink,
  ...rest
}) {
  const { pathname } = location || {};
  const isSignupPage = useMemo(
    () => pathname === routes.emailSignup.path,
    [pathname]
  );

  return (
    <Footer
      {...rest}
      ref={forwardedRef}
      signupFooterShow={signupFooterShow && !isSignupPage}
    >
      <FooterInner signupFooterShow={signupFooterShow && !isSignupPage}>
        <PageDesktopFooterColophon
          authenticated={authenticated}
          location={location}
          signupFooterShow={signupFooterShow && !isSignupPage}
        />
        <PageDesktopFooterNav
          authenticated={authenticated}
          settingsLinks={settingsLinks}
          trackOutboundLink={trackOutboundLink}
        />
        {(!signupFooterShow || isSignupPage) && (
          <ParentBrand>
            <LogoHoltCat />
          </ParentBrand>
        )}
      </FooterInner>
      {signupFooterShow && !isSignupPage && (
        <SignupFooter trackEvent={trackEvent} />
      )}
    </Footer>
  );
}

const Footer = styled.footer`
  background-color: ${colors.black};
  ${({ signupFooterShow }) =>
    signupFooterShow &&
    `display: grid; grid-template-columns: 1fr clamp(${rem("280px")}, 28.33333333vw, ${rem("408px")});`}
`;

const FooterInner = styled.div`
  display: flex;
  padding: ${rem("28px")}
    ${({ signupFooterShow }) => (signupFooterShow ? rem("22px") : rem("40px"))}
    ${rem("30px")} ${rem("22px")};

  @media (min-width: ${rem("1200px")}) {
    padding: ${rem("48px")} ${rem("60px")} ${rem("22px")};
  }
`;

const ParentBrand = styled.div`
  margin-left: auto;
  max-width: 100%;
  min-width: ${rem("150px")};
  padding-left: ${rem("18px")};
  width: ${rem("198px")};
`;

const LogoHoltCat = styled(PageLogoHoltCat)`
  height: 0;
  overflow: hidden;
  max-width: 100%;
  padding-top: 28.504672897%;
  position: relative;

  svg {
    bottom: 0;
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`;

PageDesktopFooter.propTypes = {
  authenticated: bool,
  forwardedRef: shape({
    current: instanceOf(Element),
  }),
  location: object,
  settingsLinks: array,
  signupFooterShow: bool,
  trackEvent: func,
  trackOutboundLink: func,
};

export default forwardRef((props, ref) => (
  <PageDesktopFooter {...props} forwardedRef={ref} />
));
